import { TEvent } from "src/shared/types/globalStotre.types";
import { TTeamConfig } from "src/shared/types/teamConfig.types";

type TSeatInfoOmitTotal = Omit<TEvent["seatInformation"], "totalSeatCount">;

function getSeatCountMapping() {
  return [
    {
      id: "included_with_pass",
      label: "Included With Pass",
      seatCount: 0,
      keys: ["PASS"],
    },
    {
      id: "upgraded",
      label: "Upgraded",
      seatCount: 0,
      keys: ["PRE ASSIGNMENT UPGRADE"],
    },
    {
      id: "additional_guest",
      label: "Additional Guest",
      seatCount: 0,
      keys: ["GUEST"],
    },
    {
      id: "purchased",
      label: "Purchased",
      seatCount: 0,
      keys: [
        "SINGLE GAME",
        "POST ASSIGNMENT UPGRADE",
        "UPGRADE WITHOUT EXCHANGE",
        "UPGRADE WITH EXCHANGE",
      ],
    },
    {
      id: "bought_on_marketplace",
      label: "Purchased on Marketplace",
      seatCount: 0,
      keys: ["MARKETPLACE_BUY_COUNT"],
    },
    {
      id: "gift_awaiting_redemption",
      label: "Gift Not Redeemed",
      seatCount: 0,
      keys: ["GIFT"],
    },
  ];
}

function findKeysNotInMapping(seatInformation: TSeatInfoOmitTotal) {
  const keys = Object.keys(seatInformation);
  // Exclude marketplace sell/listed counts from catch-all
  const excludeFromCatchAll = [
    "MARKETPLACE_SELL_COUNT",
    "MARKETPLACE_LISTING_COUNT",
  ];

  const keysNotInMapping = keys.filter((key) => {
    // Skip if it's in the exclude list
    if (excludeFromCatchAll.includes(key)) {
      return false;
    }

    return getSeatCountMapping().every((seatCountItem) => {
      return !seatCountItem.keys.includes(
        key as keyof TEvent["seatInformation"]
      );
    });
  });
  return keysNotInMapping;
}

function combineSeatCounts(seatInformation: TSeatInfoOmitTotal) {
  const seatCountMapping = getSeatCountMapping();
  const keysNotInMapping = findKeysNotInMapping(seatInformation);

  for (const seatCountItem of seatCountMapping) {
    seatCountItem.keys.forEach((k) => {
      const key = k as keyof TSeatInfoOmitTotal;
      seatCountItem.seatCount += seatInformation[key] || 0;
    });
  }
  if (keysNotInMapping.length > 0) {
    seatCountMapping.map((mapping) => {
      if (mapping.id === "purchased") {
        keysNotInMapping.forEach((k) => {
          const key = k as keyof typeof seatInformation;
          mapping.seatCount += seatInformation[key] || 0;
        });
      }
    });
  }

  return seatCountMapping;
}

export function itemizeSeatCounts(seatInformation: TSeatInfoOmitTotal) {
  const mappingAggregated = combineSeatCounts(seatInformation);

  // handling pre assignment upgrade heuristics
  const preAssUpCount = seatInformation["PRE ASSIGNMENT UPGRADE"] || 0;
  if (preAssUpCount > 0) {
    mappingAggregated.map((itm) => {
      if (itm.id == "included_with_pass") {
        itm.seatCount = 0;
      }
      return itm;
    });
  }
  return mappingAggregated;
}

export function filterItemizeSeatCounts(args: {
  event: TEvent;
  teamConfig: TTeamConfig;
}) {
  if (!args?.event || !args?.teamConfig) return [];

  const isReservationEnabled = args?.teamConfig?.HOME_PAGE_SETTINGS?.EVENT_CARD?.IS_RESERVATION_ENABLED || false; // prettier-ignore
  const { totalSeatCount, ...seatInfo } = args?.event?.seatInformation;
  const optedInSeatCount = args?.event?.optedInSeatCount || 0;
  const seatCountItems = itemizeSeatCounts(seatInfo);

  if (isReservationEnabled) {
    if (optedInSeatCount > 0) {
      seatCountItems.push({
        id: "opted_in",
        label: "Reserved",
        seatCount: optedInSeatCount,
        keys: ["OPTED_IN"],
      });
    }

    return seatCountItems?.filter((i) => i?.id !== "included_with_pass");
  }

  return seatCountItems;
}
